export const excludePaths = ['filtered_records.more_details', 'filteredRecords.moreDetails'];
